export default {
  buttons: {
    login: 'Connexion',
  },
  feedback: {
    incorrect_code: 'Le code que vous avez saisi est incorrect. Veuillez réessayer.',
    expired_code: 'Ce code a expiré. Veuillez en demander un nouveau.',
    too_many_attempts: 'Trop de tentatives. Veuillez patienter un moment et réessayer.',
    unknown: "Une erreur s'est produite lors de la vérification de votre code. Veuillez réessayer.",
    network_error: "Nous n'avons pas pu atteindre le serveur. Vérifiez votre connexion et réessayez.",
  },
};
